import React, { useEffect, useState } from "react";
import axios from "axios";
import InvoiceForBd from "./WithdrawalInvoice";

const statusColors = {
    0: "#faad14", // Pending - orange
    1: "#52c41a", // Approved - green
    2: "#ff4d4f", // Rejected - red
};

const BdBillList = ({ invoiceForType = "bd" }) => {
    const [bills, setBills] = useState([]);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalEntries, setTotalEntries] = useState(0);
    const [filters, setFilters] = useState({ startDate: "", endDate: "" });
    const [uniqueId, setUniqueId] = useState("");
    const [loading, setLoading] = useState(false);
    // const [viewBill, setViewBill] = useState(null);
    const [showNote, setShowNote] = useState(true);

    useEffect(() => {
        let sessionKey = invoiceForType;
        const storedData = sessionStorage.getItem(sessionKey);
        if (storedData) {
            try {
                const obj = JSON.parse(storedData);
                setUniqueId(obj.uniqueId || "");
            } catch {
                setUniqueId("");
            }
        }
    }, [invoiceForType]);

    const fetchBills = async () => {
        if (!uniqueId) return;
        setLoading(true);
        const params = {
            page,
            limit: perPage,
            uniqueId,
            invoiceForType,
            ...filters,
        };
        try {
            const res = await axios.get(`${process.env.REACT_APP_BASEURL1}/admin/withdrawal/getAllBillsFor`, { params });
            if (res.data.success) {
                setBills(res.data.details);
                setTotalEntries(res.data.totalEntries);
            }
        }catch(error) {
                console.error("Error fetching bills:", error);
                setBills([]);
                setTotalEntries(0);
        }
         finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        try {
            
            fetchBills();
        } catch (error) {
            
        }
        // eslint-disable-next-line
    }, [uniqueId, page, perPage, invoiceForType]);

    const handleFilterChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
    };

    const handleApply = () => {
        setPage(1);
        fetchBills();
    };

    // Animation for modal
    // const modalAnim = {
    //     animation: "fadeInScale 0.3s cubic-bezier(.4,2,.6,1) both"
    // };

    return (
        <div style={{
            maxWidth: 1100,
            margin: "40px auto",
            padding: "32px 20px",
            background: "#f6f9fc",
            borderRadius: 18,
            boxShadow: "0 8px 32px #0001",
            minHeight: 600,
            fontFamily: "Inter, Segoe UI, Arial, sans-serif",
            position: "relative"
        }}>
            {/* ...styles and note... */}
            <h2 style={{
                textAlign: "center",
                fontWeight: 700,
                fontSize: 32,
                letterSpacing: 1,
                marginBottom: 18,
                color: "#222"
            }}>
                My Bills
            </h2>
            {showNote && (
                <div style={{
                    background: "#fffbe6",
                    border: "1px solid #ffe58f",
                    borderRadius: 8,
                    padding: "18px 28px",
                    marginBottom: 22,
                    position: "relative",
                    color: "#ad8b00",
                    fontSize: 17,
                    boxShadow: "0 2px 12px #ffe58f33",
                    animation: "fadeInScale 0.5s"
                }}>
                    <span>
                        <b>Note:</b> Weekly bills are generated from <b>Monday</b> to <b>Sunday</b>.<br />
                        You need to submit the bills for admin approval every week.<br />
                        Only after admin approval you can download the bill.
                    </span>
                    <button
                        onClick={() => setShowNote(false)}
                        style={{
                            position: "absolute",
                            top: 8,
                            right: 12,
                            background: "transparent",
                            border: "none",
                            fontSize: 22,
                            color: "#ad8b00",
                            cursor: "pointer",
                            fontWeight: 700,
                            lineHeight: 1
                        }}
                        aria-label="Close"
                    >
                        ×
                    </button>
                </div>
            )}
            {/* ...filters, pagination, table... */}
            <div style={{
                overflowX: "auto",
                borderRadius: 10,
                boxShadow: "0 2px 12px #0001",
                background: "#fff"
            }}>
                <table style={{
                    width: "100%",
                    borderCollapse: "separate",
                    borderSpacing: 0,
                    fontSize: 16,
                    minWidth: 900
                }}>
                    <thead>
                        <tr style={{
                            background: "#f0f5ff",
                            color: "#222",
                            fontWeight: 600
                        }}>
                            <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>S.No</th>
                            <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>Start Date</th>
                            <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>End Date</th>
                            <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>Created At</th>
                            <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>Status</th>
                            <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>Paid Bill</th>
                            <th style={{ padding: 12, borderBottom: "2px solid #e6f4ff" }}>View</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={7} style={{ textAlign: "center", padding: 32, fontSize: 18, color: "#888" }}>
                                    Loading...
                                </td>
                            </tr>
                        ) : bills.length === 0 ? (
                            <tr>
                                <td colSpan={7} style={{ textAlign: "center", padding: 32, fontSize: 18, color: "#888" }}>
                                    No records found
                                </td>
                            </tr>
                        ) : (
                            bills.map((bill, idx) => (
                                <tr
                                    key={bill._id}
                                    className="bill-row"
                                    style={{
                                        background: idx % 2 === 0 ? "#fafcff" : "#f6f9fc",
                                        transition: "background 0.2s"
                                    }}
                                >
                                    <td style={{ padding: 10, textAlign: "center" }}>{(page - 1) * perPage + idx + 1}</td>
                                    <td style={{ padding: 10, textAlign: "center" }}>{bill.startDate ? new Date(bill.startDate).toLocaleDateString() : "-"}</td>
                                    <td style={{ padding: 10, textAlign: "center" }}>{bill.endDate ? new Date(bill.endDate).toLocaleDateString() : "-"}</td>
                                    <td style={{ padding: 10, textAlign: "center" }}>{bill.createdAt ? new Date(bill.createdAt).toLocaleString() : "-"}</td>
                                    <td style={{
                                        padding: 10,
                                        textAlign: "center",
                                        color: statusColors[bill.approved],
                                        fontWeight: 600,
                                        letterSpacing: 1
                                    }}>
                                        {bill.approved === 0 ? "Pending" : bill.approved === 1 ? "Approved" : "Rejected"}
                                    </td>
                                    <td style={{ padding: 10, textAlign: "center" }}>
                                        {bill.approved === 1 && bill.billPath ? (
                                            <a
                                                href={`${process.env.REACT_APP_BASEURL1}/${bill.billPath}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="download-link"
                                            >
                                                Download
                                            </a>
                                        ) : (
                                            <span style={{ color: "#aaa" }}>-</span>
                                        )}
                                    </td>
                                    <td style={{ padding: 10, textAlign: "center" }}>
                                        {bill.billPath ? (
                                            <a
                                                href={`${process.env.REACT_APP_BASEURL1}/${bill.billPath}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="bill-btn"
                                                style={{
                                                    background: "#13c2c2",
                                                    boxShadow: "0 2px 8px #13c2c244",
                                                    color: "#fff",
                                                    padding: "6px 18px",
                                                    borderRadius: 6,
                                                    fontWeight: 600,
                                                    textDecoration: "none"
                                                }}
                                            >
                                                View
                                            </a>
                                        ) : (
                                            <span style={{ color: "#aaa" }}>-</span>
                                        )}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {/* Modal for InvoiceForBd removed, now View opens PDF in new tab */}
        </div>
    );
};

export default BdBillList;